import { api } from '@packages/backend/convex/_generated/api';
import { DEFAULT_PRINTER_DISCOVERY_SDKS, type PosConfigCvx } from '@packages/shared';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { SuperAdminOnly } from '@/components/SuperAdminOnly';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';
import { DocketTemplates } from './components/DocketTemplates';
import { PosPrinters } from './components/PosPrinters';
import { PrinterDiscoverySdks } from './components/PrinterDiscoverySdks';
import { PrintJobLogging } from './components/PrintJobLogging';

export const Route = createFileRoute('/r/$restaurantId/s/pos-printers')({
  component: Component,
});

function Component() {
  const { restaurantId } = Route.useParams();
  const { data, isError, isPending } = useQuery(api.posConfigs.getByRestaurantId, {
    restaurantId,
  });

  if (isPending) return <LoadingIcon />;
  if (isError) return null; // Handled in parent layout
  if (data === null) return <div>No config yet.</div>;
  const posConfig: PosConfigCvx = data;

  return (
    <>
      <PosPrinters restaurantId={restaurantId} />
      <DocketTemplates restaurantId={restaurantId} />
      <SuperAdminOnly>
        <PrinterDiscoverySdks
          printerDiscoverySdks={
            posConfig.printerDiscoverySdks ?? [...DEFAULT_PRINTER_DISCOVERY_SDKS]
          }
          restaurantId={restaurantId}
        />
        <PrintJobLogging
          printJobLoggingEnabled={posConfig.printJobLoggingEnabled}
          restaurantId={restaurantId}
        />
      </SuperAdminOnly>
    </>
  );
}
